module.exports = __webpack_public_path__ + "img/01_uk.3b44f157.svg";